import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  isMenuOpenPreState: true,
}

const slice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    setMenuOpenState: (state, action) => ({
      ...state,
      isMenuOpenPreState: action.payload,
    })
  }
});

const {actions, reducer} = slice;
export const {
  setMenuOpenState
} = actions;
export default reducer;
